export const isHttpError = (
    error: unknown,
): error is { status: number; response: unknown } =>
    error instanceof Object &&
    'status' in error &&
    typeof error.status === 'number';
